const forgotTrigger=document.querySelector('.forgot-trigger');
const loginTrigger=document.querySelector('.login-trigger');
function showAccountPanel(recover,focusHeading){
  const forgot=document.querySelector('#forgot');
  const login=document.querySelector('#login');
  if(!forgot||!login)return;
  forgot.classList.toggle('active',recover);
  login.classList.toggle('active',!recover);
  if(focusHeading)(recover?forgot:login).querySelector('h1')?.focus();
}
forgotTrigger?.addEventListener('click',event=>{event.preventDefault();showAccountPanel(true,true);});
loginTrigger?.addEventListener('click',event=>{event.preventDefault();showAccountPanel(false,true);});
if(window.location.hash)showAccountPanel(window.location.hash==='#recover',false);
